import React, { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import InputFields from "../../utils/UserInput";
import { message, Modal } from "antd";
import ImageUpload from "./UploadImage";
import { MultiPostRequest } from "../../utils/APICall";
import moment from "moment";
import { useSelector } from "react-redux";
import UserImg from '../../assets/user.png';
import { XMarkIcon } from "@heroicons/react/16/solid";

const EditUserForm = ({ visible, onClose, userData }) => {
  //  console.log("userData-->>>>", userData)
  const { users } = useSelector((state) => state.user || {})
  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("First name is required"),
    // lastName: Yup.string().required("Last name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    userName: Yup.string().required("Username is required"),
    password: Yup.string().min(1, "Password must be at least 3 characters").required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password")], "Passwords must match")
      .required("Confirm password is required"),
    phone: Yup.string().required("Phone is required"),
    role: Yup.string().required("Role is required"),
    userType: Yup.string().required("User Type is required"),
  });

  const initialValues = {
    firstName: userData?.FIRSTNAME || "",
    lastName: userData?.LASTNAME || "",
    email: userData?.EMAIL || "",
    userName: userData?.USERNAME || "",
    password: userData?.PASSWORD || "",
    confirmPassword: userData?.PASSWORD || "",
    phone: userData?.PHONE || "",
    role: userData?.USERROLE || "",
    userType: Number(userData?.USERTYPE) || "",
    webAccess: userData?.WEB_ACCESS == 1 ? true : false,
    imageURL: userData?.IMAGEURL,
    imageId: userData?.IMAGEID,
    // employeeId:  "",
  };

  const userRoles = [
    { label: "Admin", value: 1 },
    { label: "HR", value: 4 },
    { label: "Accountant", value: 5 },
    { label: "Employee", value: 2 },
    { label: "Client", value: 3 },
  ];
  const userType = [
    { label: "Admin", value: 1 },
    { label: "Employee", value: 2 },
    { label: "Client", value: 3 },
  ];

  const handleSubmit = async (values, { resetForm }) => {
    // console.log(values);

    const formData = new FormData();
    formData.append("UserId", userData?.USERID || 0);
    formData.append("employeeId", userData?.EMPLOYEEID || 0);
    formData.append("firstName", values.firstName ? values.firstName : userData?.FIRSTNAME || null);
    formData.append("lastName",
      values.lastName === undefined || values.lastName === null
        ? null
        : values.lastName === userData?.LASTNAME
          ? userData?.LASTNAME
          : values.lastName);
    formData.append("email", values.email ? values.email : userData?.EMAIL || null);
    formData.append("userName", values.userName ? values.userName : userData?.USERNAME || null);
    formData.append("password", values.password ? values.password : userData?.PASSWORD);
    formData.append("phone", values.phone ? values.phone : userData?.PHONE || null);
    formData.append("role", isNaN(values.role) ? userData.USERROLE : values.role);
    formData.append("userType", isNaN(values.userType) ? userData.USERTYPE : values.userType);
    formData.append("createdby", `${users?.FIRSTNAME} ${users?.LASTNAME}| ${moment(Date.now()).format("DD-MM-YYYY HH:mm")}`);
    formData.append("imageId", userData?.IMAGEID || 0);
    const webAccessValue =
      values.webAccess !== "" || values.webAccess
        ? values.webAccess === true || values.webAccess === "1"
        : userData.WEB_ACCESS === 1;
    // console.log(webAccessValue)
    formData.append("webAccess", webAccessValue ? "true" : "false");

    // console.log("Submitting employee data:", Object.fromEntries(formData));
    try {
      const res = await MultiPostRequest("addUser", formData)
      // console.log("response-->>>>>>", res)
      if (res?.success) {
        message.success("User Upadated Successfully")
        onClose()
        resetForm()
        window.location.reload()

      }
    } catch (error) {
      console.log("API error", error)
    }

  };
  return (
    <Modal
      title={
        <div className="text-xl font-bold text-center dark:bg-gray-900 dark:text-gray-100">
          Update User
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      closeIcon={
        <XMarkIcon
          className={"h-5 w-5  dark:text-white text-black"}
        />
      }
      className="dark:[&_.ant-modal-content]:bg-gray-900"
    >
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize={true}
      >
        {({ values }) => (
          <Form className="dark:bg-gray-900">
            <span className="flex justify-center items-center py-4 ">
              {/* <ImageUpload setData={setDataFiles} images={images} setImages={setImages} /> */}
              <div
                className="relative w-32 h-32 rounded-full overflow-hidden shadow-lg border border-gray-200"
              >
                <img
                  src={values?.imageURL || UserImg}
                  alt={`Uploaded `}
                  name="imageURL"
                  className="w-full h-full object-contain"
                />
              </div>
            </span>
            <span className="grid  grid-cols-1 gap-2 md:grid-cols-2 ">
              <InputFields
                label="First Name"
                type="text"
                placeholder="Enter your firstName"
                name="firstName"
              />
              <InputFields
                label="Last Name"
                type="text"
                placeholder="Enter lastName"
                name="lastName"
              />

              <InputFields
                label="Email"
                type="email"
                name="email"
                placeholder="Enter Email"
              />
              <InputFields
                label="User Name"
                type="text"
                placeholder="Enter userName"
                name="userName"
              />
              <InputFields
                label="Password"
                type="password"
                name="password"
                placeholder="Enter Password"
                iconRender={() => null}
              />
              <InputFields
                label="Confirm Password"
                type="password"
                placeholder="Enter confirmPassword"
                name="confirmPassword"
                iconRender={() => null}
              />
              <InputFields
                label="Phone"
                type="number"
                name="phone"
                placeholder="Enter Phone"
              />
              <InputFields
                label="User Role"
                type="select"
                placeholder="Enter Role"
                name="role"
                options={userRoles}
              />
              <InputFields
                label="User Type"
                type="select"
                placeholder="Enter Role"
                name="userType"
                options={userType}
              />
              <InputFields
                label="Web Acces"
                type="checkbox"
                name="webAccess"
              />
            </span>
            <button
              type="submit"
              className="mt-6 relative ml-auto w-full max-h-10 bg-green-500 text-white px-4 py-2 rounded"
            >
              Update
            </button>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default EditUserForm